module.exports = __webpack_public_path__ + "img/lsjc_2.63cf3092.png";